<script lang="ts" setup>
import type { TUiTypeValues } from '@/types/api/reports'
import { getCorrectnessActionGroups } from '@/helpers/constants'
import { t } from '@/locales/i18n'
import { computed } from 'vue'
import GwTooltipNew from '@/components/lib/GwTooltip/GwTooltipNew.vue'

interface GtoScoreProps {
  value: TUiTypeValues['hand_correctness']
  isTableValue?: boolean
}
const props = defineProps<GtoScoreProps>()

const score = computed(() => (props.value === 'unsolved' ? 'na' : props.value))
const actionGroup = computed(() => getCorrectnessActionGroups()[score.value])
</script>

<template>
  <div
    v-if="isTableValue"
    class="w-100 d-flex f-start"
  >
    <GwTooltipNew placement="right">
      <template #opener="{ listeners }">
        <div
          class="mdi mr-auto pr-1"
          :style="`color: var(--app-clr-${score})`"
          :class="actionGroup?.icon || ''"
          v-on="listeners"
        />
      </template>
      <template #tooltip>
        <span
          :style="isTableValue ? `color: var(--app-clr-white})` : ''"
          v-html="t(`practice.${score}`)"
        />
      </template>
    </GwTooltipNew>
  </div>
  <div
    v-else
    class="truncate d-flex"
  >
    <div
      class="mr-1 mdi"
      :style="`color: var(--app-clr-${score})`"
      :class="actionGroup?.icon || ''"
    />
    <span
      :style="isTableValue ? `color: var(--app-clr-${score})` : ''"
      v-html="t(`practice.${score}`)"
    />
  </div>
</template>
